import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { message, Form } from 'antd';
import { startGetLista, startSolicitar } from '../../context/actions/reembolsosActions';
import { getColumns } from './tabla/columns';

export const useReembolsosPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { reembolsos, loading } = useSelector((s) => s.reembolsosReducer);
  const [estatus, setEstatus] = useState(1);
  const [modalCrear, setModalCrear] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(startGetLista(estatus));
  }, [estatus, dispatch]);

  const refresh = () => dispatch(startGetLista(estatus));

  const columns = useMemo(() => getColumns(reembolsos), [reembolsos]);

  const handleOk = async () => {
    const values = await form.validateFields();
    try {
      const id = await dispatch(startSolicitar({
        asistenciaID: values.asistenciaID,
        descripcion: values.descripcion,
        monto: values.monto,
        nombreUsuarioFinalSolicita: values.nombreUsuario,
        telefonoUsuarioFinalSolicita: values.telefono,
        motivoReembolso: values.motivoReembolso,
      }));
      message.success('Reembolso creado');
      form.resetFields();
      setModalCrear(false);
      history.push(`/reembolsos/detalle/${id}`);
    } catch (e) {
      message.error(e.message || 'Error al crear reembolso');
    }
  };

  const handleCancelModal = () => {
    form.resetFields();
    setModalCrear(false);
  };

  return {
    reembolsos, loading, columns,
    estatus, setEstatus,
    modalCrear, setModalCrear,
    form, handleOk, handleCancelModal,
  };

};